import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { LiveKitModels } from '@models/livekit.model';
import { LiveKitActions } from '@states/live-kit/live-kit.action-types';
import { setInitialLoader } from '@states/live-kit/live-kit.actions';

export declare interface LiveKitState extends EntityState<LiveKitModels.Server> {
  summary: LiveKitModels.Summary;
  initialLoading: boolean;
}

export const liveKitAdapter: EntityAdapter<LiveKitModels.Server> = createEntityAdapter<LiveKitModels.Server>({
  selectId: (server: LiveKitModels.Server) => server.serverName,
});

const initialState: LiveKitState = liveKitAdapter.getInitialState({
  summary: null,
  initialLoading: true,
});

export const liveKitStateReducer = createReducer(
  initialState,
  on(LiveKitActions.resetToInitialState, state => {
    return {
      ...initialState,
    };
  }),
  on(LiveKitActions.getLiveKitRoomListSuccess, (state, { servers, summary }) => {
    return liveKitAdapter.setAll(servers, { ...state, summary });
  }),
  on(LiveKitActions.removeLiveKitSuccess, (state, { server }) => {
    return liveKitAdapter.updateOne({
      id: server.serverName,
      changes: {
        ...server,
      },
    }, { ...state });
  }),
  on(LiveKitActions.setInitialLoader, (state, { loading }) => {
    return {
      ...state,
      initialLoading: loading,
    };
  }),
);
